import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import Offers from './offers';
import { getOffers, isLoaded } from '../redux/modules/loan';
import { getDetailText } from '../redux/modules/detailText';
import * as date from '../utils/date-fns';
import DetailTextSection from '../DetailTextSection';

const Bundle = __CLIENT__ ? require('../common/bundle').default : null;
const Article = __CLIENT__
  ? require('bundle-loader?lazy!./loan.article.js')
  : require('./loan.article.js').default;

const OFFER_TYPE = 'loans';

/** Read and decode ':filter' from router props */
function getFilterFromProps(props) {
  const m = props && props.match;
  return decodeURIComponent((m && m.params && m.params.filter) || '');
}

class Loan extends Component {
  static fetchData = async ({ getState, dispatch, params, match }) => {
    if (!isLoaded({ getState })) {
      await dispatch(getOffers());
    }
    const filter =
      (params && params.filter) ||
      (match && match.params && match.params.filter) ||
      '';
    if (filter) {
      await dispatch(getDetailText(OFFER_TYPE, filter));
    }
  };

  render() {
    const { match, location, feed } = this.props;
    const filter = getFilterFromProps(this.props);

    return (
      <DocumentMeta
        title={`${
          match.params && match.params.filter ? match.params.filter + ' ' : ''
        }Lån penge, sammenlign hurtigt billige lån (${date.format(
          new Date(),
          'MMMM \'YY'
        )})`}
        canonical={`/${encodeURI('lån')}`}
        extend
      >
        <Offers {...this.props} category={OFFER_TYPE} />

        <hr />

        <DetailTextSection
          offerType={OFFER_TYPE}
          filter={filter}
          location={location}
          feed={feed}
          // Mirror the old fallback logic exactly
          fallback={
            __CLIENT__ ? (
              <Bundle load={Article}>{Comp => (Comp ? <Comp /> : null)}</Bundle>
            ) : (
              <Article />
            )
          }
        />
      </DocumentMeta>
    );
  }
}

// (Optional) Keep this if other props are needed; DetailTextSection connects itself for detailText.
const mapStateToProps = state => ({});

export default withRouter(connect(mapStateToProps, { getOffers })(Loan));